import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { DestroyableComponent } from '@core/destroyable';
import { ImageLinkRequest } from '@models/image-link-request.model';
import { ImageType } from '@models/image-type.model';
import { ImageUploadRequest } from '@models/image-upload-request.model';
import { takeUntil } from 'rxjs/operators';
import { CommonService } from '@services/common.service';
import { Modem } from '@models/modem.model';

@Injectable()
export class ModemService extends DestroyableComponent {
	private http = inject(HttpClient);

	public GetAvailableModems(relationGuid: string): Promise<Modem[]> {
		return new Promise<Modem[]>((resolve, reject) => {
			this.http
				.get<Modem[]>(`modems/${relationGuid}`)
				.pipe(takeUntil(this.ngUnsubscribe))
				.subscribe(
					(result) => resolve(result),
					(error) => reject(error),
				);
		});
	}
}
